/* eslint-disable @angular-eslint/prefer-standalone */
import { Component, inject } from '@angular/core';

import { AppService } from './common/app.service';
import { AppStore } from './common/app.store';
import { PendingUsersStore } from './common/data/users.store';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss'],
    standalone: false
})
export class AppComponent {
  public app = inject(AppService);
}
